import React, { Component } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import moment from 'moment-timezone';
import { GenericObj } from '@solvhealth/types/interfaces/generics';
import { stripNonNumeric } from '../../../core/util/string';
import {
  calculateDefaultRelationshipType,
  isOldEnoughToCreateAccount,
  RELATIONSHIP_OPTIONS,
  BIRTH_SEX_OPTIONS,
} from '../../../core/util/account';

import Tooltip from '../../ToolTip';
import { dobYearValidator, emptyFieldValidator } from '../../../core/util/rcForm/validators';
import {
  RELATIONSHIP_ALLOW_UNDERAGE_TYPES,
  RELATIONSHIP_TYPE_CHILD,
} from '../../../constants/index';

import Button, { ButtonVariations } from '../../SolvPatternLibrary/Button';
import TextField from '../../SolvPatternLibrary/TextField';
import { isEmpty } from '../../../core/util/empty';
import { validateDob, validateSex } from '../../../core/util/form';
import SelectTextField from '../../SolvPatternLibrary/SelectTextField';
import { formatMonth, getDays, getMonths } from '../../SolvPatternLibrary/BirthDateInput/util';
import { fontFamily, fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';
import { standardizeYear } from '../../../core/util/date';

const MOBILE_CONTAINER_MAX_WIDTH = '330px';
const SHORT_WIDTH = 22;
const DAY_YEAR_OFFSET = 4;

const FormContainer = styled(Grid)`
  width: 90%;
  max-width: ${MOBILE_CONTAINER_MAX_WIDTH};
  margin: 24px auto;
`;
const ShortInputContainer = styled(Grid)`
  max-width: ${SHORT_WIDTH}%;
  flex-basis: 22%;
  margin: 21px 0 5px;
`;
const MediumInputContainer = styled(Grid)`
  max-width: 48%;
  flex-basis: 48%;
  margin: 21px 0 5px;
`;
const LargeInputContainer = styled(Grid)`
  margin: 21px auto 5px;
`;
const DayInputContainer = styled(ShortInputContainer)`
  max-width: ${SHORT_WIDTH - DAY_YEAR_OFFSET}%;
`;
const YearInputContainer = styled(ShortInputContainer)`
  max-width: ${SHORT_WIDTH + DAY_YEAR_OFFSET}%;
`;
const ButtonContainer = styled.div`
  margin: 20px 0;
`;
const SaveButton = styled(Button)`
  padding: 8px 12px 8px 0px;
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.bold};
`;
const CancelButton = styled(Button)`
  padding: 8px 12px 8px 12px;
  font-size: ${fontSize.mediumSmall};
`;
const ConfirmGuardian = styled.div`
  margin-top: 8px;
  text-align: center;
`;
const ConfirmButton = styled(Button)`
  background-color: ${colors.theWhiteAlbum};
`;
const StyledTextField = styled((props) => (
  <TextField
    InputLabelProps={{ classes: { root: 'label-root' } }}
    InputProps={{ classes: { root: 'root' } }}
    {...props}
  />
))`
  background-color: white;

  & .root {
    margin-top: 0;
  }

  & .label-root {
    top: -6px;
  }
`;

const StyledSelectField = styled((props) => (
  <SelectTextField
    InputLabelProps={{ classes: { root: 'label-root' } }}
    InputProps={{ classes: { root: 'root' } }}
    {...props}
  />
))`
  background-color: white;

  & .root {
    margin-top: 0;
  }

  & .label-root {
    top: -6px;
  }
`;

type Props = {
  form: formShape;
  userProfile?: any;
  handleFormSubmit?: (...args: any[]) => any;
  handleCancel?: (...args: any[]) => any;
};

type State = any;

class EditProfileForm extends Component<Props, State> {
  state = {
    submitting: false,
    errors: {} as GenericObj,
    buttonStatus: 'initial',
    submitButtonDisabled: true,
    guardianConfirmation: false,
    relationshipHelperText: null,
  };

  onBlur = (fieldName: any) => {
    const { form } = this.props;
    form.validateFields([fieldName], {}, (errors: any) => {
      this.enableFormSubmissionIfNoErrors(errors);
      if (isEmpty(errors)) {
        this.setState({ errors: { [fieldName]: false } });
      } else {
        this.setState((state: any) => ({
          errors: {
            ...state.errors,
            [fieldName]: errors[fieldName],
          },
        }));
      }
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields(this.onValidationDone);
  };

  onValidationDone = (fieldErrors: any, values: any) => {
    const dobErrors = validateDob(values.dobMonth, values.dobDay, values.dobYear);
    const birthDate = `${values.dobYear}-${formatMonth(values.dobMonth, 'MM')}-${values.dobDay}`;
    const birthSexErrors = validateSex(values.birthSex);
    const formErrors = { ...fieldErrors, ...dobErrors, ...birthSexErrors };
    if (this.props.userProfile && isEmpty(formErrors)) {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.handleFormSubmit({ ...values, birthDate });
    } else if (
      !isOldEnoughToCreateAccount(birthDate) &&
      this.state.guardianConfirmation &&
      !RELATIONSHIP_ALLOW_UNDERAGE_TYPES.includes(values.relationshipToAccount)
    ) {
      this.setState((state: any) => ({
        relationshipHelperText: 'You must be at least 13 years old to use Solv.',

        errors: {
          ...state.errors,
          guardianConfirmation: false,
          relationshipToAccount: true,
        },
      }));
    } else if (!isOldEnoughToCreateAccount(birthDate) && !this.state.guardianConfirmation) {
      this.setState((state: any) => ({
        relationshipHelperText: null,

        errors: {
          ...state.errors,
          guardianConfirmation: true,
          relationshipToAccount: false,
        },
      }));
    } else if (isEmpty(formErrors)) {
      this.setState({ submitting: true });

      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.handleFormSubmit({ ...values, birthDate });
    } else if (!isEmpty(formErrors)) {
      this.setState({ errors: formErrors });
    }
  };

  onFieldChange = (value: any, fieldName: any) => {
    const { form } = this.props;
    const { errors } = this.state;
    this.setState((state: any) => ({
      errors: {
        ...state.errors,
        [fieldName]: false,
      },
    }));
    form.setFieldsValue({ [fieldName]: value });

    form.validateFields(this.enableFormSubmissionIfNoErrors);
  };

  getOptions = (array: any) =>
    array.map((value: any) => {
      const optionValue = value || '';
      return {
        key: optionValue.toLowerCase(),
        value: optionValue.toLowerCase(),
        label: optionValue,
      };
    });

  getRelationship = (userProfile: any) =>
    userProfile && !isEmpty(userProfile.relationship_to_account)
      ? userProfile.relationship_to_account
      : calculateDefaultRelationshipType(userProfile);

  getBirthSex = (userProfile: any) =>
    userProfile && !isEmpty(userProfile.birth_sex) ? userProfile.birth_sex : '';

  getBirthDateFromForm = () => {
    const { getFieldsValue } = this.props.form;
    let birthDate = '';
    const values = getFieldsValue();
    if (values.dobYear && values.dobMonth && values.dobDay) {
      birthDate = `${values.dobYear}-${formatMonth(values.dobMonth, 'MM')}-${values.dobDay}`;
    }

    return birthDate;
  };

  getGuardianTooltip = () =>
    this.shouldShowGuardianTooltip() && (
      <Tooltip
        // @ts-expect-error ts-migrate(2769) FIXME: Property 'name' does not exist on type 'IntrinsicA... Remove this comment to see the full error message
        closeable={false}
        name="guardianConfirmation"
        position="bottomCenter"
        showArrow
        showUnderlay={false}
        theme="blue"
      >
        <div>
          Please acknowledge you are the parent/guardian since patients must be 13 years or older to
          book or create an account.
        </div>

        <ConfirmGuardian>
          <ConfirmButton
            disabled={this.state.submitting}
            onClick={this.confirmGuardian}
            status={this.state.buttonStatus}
            text="I am parent/guardian"
            type="submit"
            variation="tertiary"
            width="280px"
          />
        </ConfirmGuardian>
      </Tooltip>
    );

  validateDobFields = () =>
    this.props.form.validateFields(
      ['dobYear', 'dobMonth', 'dobDay'],
      {},
      (fieldErrors: any, values: any) => {
        const dobErrors = validateDob(values.dobMonth, values.dobDay, values.dobYear);
        const formErrors = { ...fieldErrors, ...dobErrors };
        this.setState({ errors: formErrors });
      }
    );

  shouldShowGuardianTooltip = () => {
    if (this.props.userProfile) {
      return false;
    }

    const birthDate = this.getBirthDateFromForm();
    return !isOldEnoughToCreateAccount(birthDate) && !this.state.guardianConfirmation;
  };

  confirmGuardian = () => {
    this.onFieldChange(RELATIONSHIP_TYPE_CHILD.toLocaleLowerCase(), 'relationshipToAccount');
    this.setState({ guardianConfirmation: true }, this.props.form.validateFields);
  };

  enableFormSubmissionIfNoErrors = (errors: any) =>
    isEmpty(errors)
      ? this.state.submitButtonDisabled && this.setState({ submitButtonDisabled: false })
      : this.state.submitButtonDisabled || this.setState({ submitButtonDisabled: true });

  render = () => {
    const { errors } = this.state;
    const { userProfile, form } = this.props;

    return (
      <Grid item xs={12}>
        <form data-testid="form" onSubmit={this.onSubmit}>
          <FormContainer container justify="space-between">
            <MediumInputContainer item xs={6}>
              <StyledTextField
                {...form.getFieldProps('firstName', {
                  rules: [{ required: true }],
                  initialValue: (userProfile && userProfile.first_name) || '',
                })}
                error={Boolean(errors.firstName)}
                fullWidth
                label="First Name"
                onBlur={() => this.onBlur('firstName')}
                onChange={({ target: { value } }: any) => this.onFieldChange(value, 'firstName')}
              />
            </MediumInputContainer>

            <MediumInputContainer item xs={6}>
              <StyledTextField
                {...form.getFieldProps('lastName', {
                  rules: [{ required: true }],
                  initialValue: (userProfile && userProfile.last_name) || '',
                })}
                error={Boolean(errors.lastName)}
                fullWidth
                label="Last Name"
                onBlur={() => this.onBlur('lastName')}
                onChange={({ target: { value } }: any) => this.onFieldChange(value, 'lastName')}
              />
            </MediumInputContainer>

            {this.getGuardianTooltip()}

            <MediumInputContainer item xs={6}>
              <StyledSelectField
                {...form.getFieldProps('dobMonth', {
                  rules: [{ required: true }],
                  initialValue:
                    (userProfile && moment(userProfile.birth_date).format('MMMM')) || '',
                })}
                error={Boolean(errors.dobMonth)}
                fullWidth
                label="Birthdate: Month"
                onChange={({ target: { value } }: any) => this.onFieldChange(value, 'dobMonth')}
                selectOptions={getMonths()}
              />
            </MediumInputContainer>

            <DayInputContainer item xs={3}>
              <StyledSelectField
                {...form.getFieldProps('dobDay', {
                  rules: [{ required: true }],
                  initialValue: (userProfile && moment(userProfile.birth_date).format('D')) || '',
                })}
                error={Boolean(errors.dobDay)}
                fullWidth
                label="Day"
                onChange={({ target: { value } }: any) => this.onFieldChange(value, 'dobDay')}
                selectOptions={getDays()}
              />
            </DayInputContainer>

            <YearInputContainer item xs={3}>
              <StyledTextField
                {...form.getFieldProps('dobYear', {
                  rules: [{ required: true, validator: dobYearValidator }],
                  initialValue:
                    (userProfile && moment(userProfile.birth_date).format('YYYY')) || '',
                })}
                error={Boolean(errors.dobYear)}
                fullWidth
                inputProps={{
                  maxLength: 4,
                }}
                label="Year"
                onBlur={({ target: { value } }: any) => {
                  this.onFieldChange(String(standardizeYear(value)), 'dobYear');
                  this.validateDobFields();
                }}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(stripNonNumeric(value), 'dobYear')
                } // jscs:disable
              />
            </YearInputContainer>

            <LargeInputContainer item xs={12}>
              <StyledSelectField
                {...form.getFieldProps('relationshipToAccount', {
                  initialValue: this.getRelationship(userProfile),
                  rules: [{ required: true, validator: emptyFieldValidator }],
                })}
                error={Boolean(errors.relationshipToAccount)}
                fullWidth
                helperText={this.state.relationshipHelperText || ''}
                label="Relationship to Account"
                onBlur={() => this.onBlur('relationshipToAccount')}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, 'relationshipToAccount')
                }
                selectOptions={this.getOptions(RELATIONSHIP_OPTIONS)}
              />
            </LargeInputContainer>

            <LargeInputContainer item xs={12}>
              <StyledSelectField
                {...form.getFieldProps('birthSex', {
                  initialValue: this.getBirthSex(userProfile),
                })}
                error={!!errors.birthSex}
                fullWidth
                helperText={errors.birthSex}
                label="Birth Sex"
                onBlur={() => this.onBlur('birthSex')}
                onChange={({ target: { value } }: any) => this.onFieldChange(value, 'birthSex')}
                selectOptions={this.getOptions(BIRTH_SEX_OPTIONS)}
              />
            </LargeInputContainer>

            <ButtonContainer>
              <SaveButton
                data-testid="editprofile-submit"
                disabled={this.state.submitting}
                status={this.state.buttonStatus}
                text="SAVE"
                type="submit"
                variation={ButtonVariations.link}
              />
              {this.props.handleCancel && (
                <CancelButton
                  onClick={this.props.handleCancel}
                  text="CANCEL"
                  variation={ButtonVariations.link}
                />
              )}
            </ButtonContainer>
          </FormContainer>
        </form>
      </Grid>
    );
  };
}

export default createForm()(EditProfileForm);
